<template>
  <GlobalModal
    data-test-id="access-denied-modal"
    v-model:is-modal-visible="isModalVisible"
    :is-header-visible="false"
    :is-footer-visible="false"
  >
    <template #modal-body>
      <v-btn
        icon="mdi-close"
        data-test-id="access-denied-close-cta"
        variant="text"
        aria-label="Close dialog"
        class="position-absolute top-0 right-0 ma-2"
        @click="isModalVisible = false"
      />
      <div data-test-id="access-denied-header" class="text-center mb-6">
        <v-avatar
          data-test-id="access-denied-avatar"
          size="72"
          color="error"
          variant="tonal"
          class="mb-4"
        >
          <v-icon data-test-id="access-denied-icon" icon="mdi-shield-lock-outline" size="40" />
        </v-avatar>

        <div data-test-id="access-denied-title" class="text-h5 font-weight-bold">
          You are not authorized to perform this action.
        </div>
      </div>

      <v-alert
        data-test-id="access-denied-message"
        type="warning"
        variant="tonal"
        border="start"
        class="mb-4"
      >
        {{ accessDeniedMessage }}
      </v-alert>

      <div data-test-id="access-denied-guidance" class="text-body-2 text-medium-emphasis mb-6">
        If you believe you should have access to this feature, please contact your administrator.
      </div>
    </template>
  </GlobalModal>
</template>

<script lang="ts" setup>
import GlobalModal from '@/components/common/modals/GlobalModal.vue';

type Props = {
  accessDeniedMessage: string;
};

defineProps<Props>();

const isModalVisible = defineModel<boolean>('isModalVisible');
</script>
